/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Premsagar Choudhary <premsagar.choudhary@mroads.com>, June 2023
 * @flow
 */

import React from 'react';
import { useSelector } from 'react-redux';
import {
  Dialog,
  DialogContent,
  DialogTitle,
  Typography,
  Box,
  IconButton,
  Button
} from '@material-ui/core';
import { Close as CloseIcon } from '@material-ui/icons';
import useStyles from './useStyles';
import Footer from './Footer';
import FireboardUtils from '../../../../util/fireboard-util';
import cssStyles from './Styles.module.css';

const CheckLookup = ({
  open,
  onClose,
  data,
}) => {
  const classes = useStyles();
  const { currencyInfo, labelsData } = useSelector(state => state);
  const labels = labelsData?.labels;
  const { currency } = currencyInfo || {};

  return (
    <Dialog
      open={open}
      aria-labelledby="dialog-title"
      aria-describedby="dialog-description"
      PaperProps={{
        style: {
          minHeight: '50%',
          minWidth: '70%',
        }
      }}
    >
      <DialogTitle id="dialog-title" className={classes.dialogTitleContainer} disableTypography>
        <Typography variant="body1" className={classes.dialogTitle}>{labels.CHECK_LOOKUP_SELECT_A_CHECK}</Typography>
        {onClose ? (
          <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
            <CloseIcon />
          </IconButton>
        ) : null}
      </DialogTitle>
      <DialogContent className={classes.dialogContent}>
        <Box height={'70vh'} overflow={'scroll'}>
          <table className={cssStyles.table}>
            <TableHeader labels={labels} />
            <TableBody data={data} currency={currency} />
          </table>
        </Box>
        <Footer
          onClose={onClose}
          onOk={() => data?.allAction(data?.list)}
          cancelText={'Cancel'}
          okText={data?.allActionText}
        />
      </DialogContent>
    </Dialog>
  );
};

export default CheckLookup;

const TableHeader = ({ labels }) => {
  return (
    <thead>
      <tr>
        <th>{labels.CHECK_LOOKUP_CHECK_NUM}</th>
        <th>{labels.CHECK_LOOKUP_TABLE_NUM}</th>
        <th>{labels.CHECK_LOOKUP_EMPLOYEE}</th>
        <th>{labels.CHECK_LOOKUP_OPEN}</th>
        <th>{labels.CHECK_LOOKUP_CLOSE}</th>
        <th>{labels.CHECK_LOOKUP_TOTAL}</th>
        <th></th>
      </tr>
    </thead>
  );
};

const TableBody = ({ data, currency }) => {
  const { list, actionText, eachAction } = data || {};
  const checks = Array.isArray(list) ? list : [];
  const classes = useStyles();

  return (
    checks.map(eachCheck => (
      <tbody key={`id-${eachCheck.id}`}>
        <tr>
          <td>{eachCheck?.checkNumber}</td>
          <td>{eachCheck?.stationNumber}</td>
          <td>{eachCheck?.employeeFirstName} {eachCheck?.employeeLastName}</td>
          <td>{FireboardUtils.getTimeInHrsMins(eachCheck?.openDate)}</td>
          <td>{FireboardUtils.getTimeInHrsMins(eachCheck?.closeDate)}</td>
          <td>{currency}{eachCheck?.totalAmount}</td>
          <td>
            <Button variant='outlined' size='small' style={{ width: '100px' }} className={classes.secondaryButton} onClick={() => eachAction && eachAction(eachCheck)}>
              {actionText}
            </Button>
          </td>
        </tr>
      </tbody>
    ))
  );
};
